(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';
	const slideSpeed = '400';

	// ＜ルート設定対応＞要素が空だったら削除
	const removeElmIfEmpty = () => {
		$('.js-checkEmptyElm').each((idx, val) => {
			if (!$(val).text().length) {
				$(val).remove();
			}
		});
	}
	// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
	const removeBlockIfListEmpty = () => {
		if ($('.js-checkEmptyList').length) {
			$('.js-checkEmptyList').each((idx, val) => {
				if (!$(val).find('li').length) {
					$(val).parents('.js-checkEmptyList-wrap').remove();
				}
			});
		}
	};

	//removeElmIfEmpty();
	//removeBlockIfListEmpty();

})(window.jQuery, window.FUNCTIONS);
